
import * as React from "react";

interface IInputTimeProps {
    value:string
    name:string
    onChange:Function
    disabled?:boolean
}

interface IInputTimeState {
}

export default class InputTime extends React.Component<IInputTimeProps, IInputTimeState>{

  	constructor(props:IInputTimeProps){
        super(props);
    }

    render() {
        let disabled = this.props.disabled !== undefined?this.props.disabled:false;
        return (
            <div className="input_time_comp">
                <input
                    className={"s-form-control"+" view"}
                    maxLength={5}
                    type="text"
                    name={this.props.name}
                    value={this.props.value} onChange={ e => {}}

                />
                <input
                    className={"s-form-control"+" input"}
                    maxLength={5}
                    type="time"
                    name={this.props.name}
                    value={this.props.value} onChange={ e => this.props.onChange(e) }

                />
			</div>
        );
    }
}
